import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from 'src/app/modules/admin/admin.service';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { BoxService } from 'src/app/shared/services/box.service';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';

@Component({
    selector: 'app-connection-collaboration',
    templateUrl: './connection-collaboration.component.html',
    styleUrls: ['./connection-collaboration.component.scss'],
    standalone: false
})
export class ConnectionCollaborationComponent implements OnInit {

  restoreInput: number = 0;
  isShowInvite: boolean = false;
  connection: any;
  availableRoles: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public dialogData: any, 
    public dialogRef: MatDialogRef<ConnectionCollaborationComponent>,
    private boxService: BoxService,
    public spinner: SpinnerService,
    public adminService: AdminService,
    public connectionService: ConnectionService,
    public authservice: AuthServiceService
    ) { 
    console.log("DIALOGREF dialogData : ", dialogData);
  }

  ngOnInit(): void {
    this.connection = this.dialogData.resource
    this.getRoles()
  }

  async getRoles(){
    var defaultRoles = await this.adminService.listRole(1, 500, this.connectionService.preAuthenticatedToken, {filter: "resource_type=default|string"})
    // var bloomRoles = await this.adminService.listRole(1, 500, this.connectionService.preAuthenticatedToken, {filter: `resource_type=bloom|string,resource_id=${this.bloomMap.code}|string`})
    // var availableRoles = defaultRoles.data.concat(bloomRoles.data);
    // this.availableRoles = availableRoles;
    this.availableRoles = defaultRoles.data;
    console.log("Available Roles  : ",this.availableRoles)
  }

  resetLoading(){
    this.restoreInput += 1
  }

}
